






















import Vue from 'vue'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { History } from '@/modules/History/interfaces/history'
import AppDialog from '@/components/AppDialog.vue'

@Component({
  components: {
    AppDialog
  }
})
export default class PolicyHistoryDetail extends Vue {
  @Prop({ type: Object as () => History }) readonly history!: History

  lists: any = [];

  showDialog = false

  mounted () {
    this.historyChanged(this.history)
  }

  @Watch('history')
  historyChanged (val: History) {
    if (!val) {
      return
    }

    const { additionalInfo } = val

    const addtionalInfoObj = JSON.parse(additionalInfo || '{}')
    const lists = []

    if (!addtionalInfoObj.updates) {
      this.lists = []
    } else {
      for (const key in addtionalInfoObj.updates) {
        if (key === 'additionalInfoStr') {
          continue
        }
        const val = addtionalInfoObj.updates[key]
        if (val) {
          lists.push({
            name: key,
            from: val.from || '',
            to: val.to || ''
          })
        }
      }

      this.lists = lists
    }

    this.showDialog = true
  }

  @Watch('showDialog')
  onDialogClose (val: boolean) {
    this.closeDialog()
  }

  @Emit('close')
  closeDialog () {
    return false
  }
}
